import axios from "axios";
import buildURL from "axios/lib/helpers/buildURL";
import { Message, Loading } from "element-ui";
import { store } from "xijs";
import router from "../../router";
import { merge } from "axios/lib/utils";

let loading = null;
//判断指定参数是否是一个纯粹的对象，所谓"纯粹的对象"，就是该对象是通过"{}"或"new Object"创建的
function isPlainObject(val) {
  return val && val.constructor.name === "Object";
}

//请求之前进行拦截，可做的操作：1、添加loading的加载；2、添加请求头；3、判断表单提交还是json提交
let requestInterceptors = [
  config => {
    //添加loading的加载
    if (!loading) {
      loading = Loading.service({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
    }
    //添加请求头
    config.headers = {
      "content-type": "application/json"
    };
    let { value } = store.get("kxccAI_token");
    // if(!value) return router.replace('/login')
    config.headers.token = value;
    // config.headers.token = sessionStorage.getItem('Token');
    //判断表单提交还是json提交
    if (config.emulateJSON && isPlainObject(config.data)) {
      config.data = buildURL("", config.data).substr(1);
    }
    return config;
  }
];

//请求响应之后进行拦截，可做操作：1、取消loading的加载；2、对返回状态进行判断：如请求错误、请求超时、获取数据失败、暂无数据等等
let responseInterceptors = [
  res => {
    //取消loading加载
    if (loading) {
      loading.close();
    }
    //对返回状态进行判断：如请求错误、请求超时、获取数据失败等等
    let data = res.data;
    if (data.code >= 0) return Promise.resolve(data);
    else if (data.code == -10010) {
      // localStorage.removeItem("kxccAI_token");
      router.push("/login");
      Message({ type: "error", message: data.message });
      return Promise.reject(data);
    } else if (data.code == -1) {
      Message({ type: "error", message: data.message });
      // setTimeout(() => {
      //   router.push("/home");
      // }, 3000);
      return Promise.reject(data);
    } else {
      // Message({ type: "error", message: data.message });
      
      return data;
    }
    //返回结果
    // return;
  },
  err => {
    //取消loading加载
    if (loading) {
      loading.close();
    }
    //对返回状态进行判断：如请求错误、请求超时、获取数据失败等等
    // this.$message.error('请求超时');
    Message({ type: "error", message: "请求超时" });
    //返回结果
    return Promise.reject(err);
  }
];

//组装请求
let serviceCreate = config => {
  let service = axios.create(merge({}, config));
  service.interceptors.request.use(...requestInterceptors);
  service.interceptors.response.use(...responseInterceptors);
  return service;
};
serviceCreate();
export { serviceCreate, merge };



// WEBPACK FOOTER //
// ./src/api/modules/request.js